import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Task 09: tab nhật ký — render ring buffer (cap 200, trống thì rỗng).
// PanelLogEntry định nghĩa tại đây để tránh circular import (SSOT cho hook/context).
import styles from "./TradingBottomPanel.module.css";
export function TradingLogTab({ log }) {
    return (_jsx("div", { className: styles.logList, "data-testid": "log-tab", children: log.map((entry, index) => (_jsxs("div", { "data-testid": `log-row-${index}`, children: [new Date(entry.timestamp).toLocaleString(), " \u2014 ", entry.message] }, `${entry.timestamp}-${index}`))) }));
}
